import { render } from "./select-day-template.vue?vue&type=template&id=01679402&scoped=true&ts=true"
import script from "./select-day-template.vue?vue&type=script&lang=ts"
export * from "./select-day-template.vue?vue&type=script&lang=ts"

import "./select-day-template.vue?vue&type=style&index=0&id=01679402&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01679402"]])

export default __exports__